import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationModels } from '@wz-models';
import { Observable } from 'rxjs';
import { Adresse } from '../../components/Souscriptions/models/Adresse.model';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class AdresseNewApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'adressenew');
  }

  getVillesCodesPostales(): Observable<Adresse[]> {
    return this.getListVillesCodePostales('/getlistvcp');
  }

  getVillesByCodePostale(postalcode: string): Observable<Adresse[]> {
    return this.getListVillesByCodePostales('/getlistvcp/' + postalcode);
  }
}
